<template>
  <div class="Paylist">
    <div class="topBar">
      <div class="subTitle">
        <i
          class="far fa-window-minimize"
          style="transform:rotate(90deg);margin-right:-10px;color:rgba(52,152,219,1);"
        ></i>
        白条列表
        <div class="rutun">
          <div>
            <i class="fas fa-sync-alt"></i>
          </div>
          <div style="margin-left:4px" @click="geting(1)">刷新</div>
        </div>
      </div>
    </div>

    <div v-if="role" style="width: 1056px;margin: 0 auto">
      <div class="form-title">
        <div style="float: left;line-height: 46px;padding-left: 10px;">筛选查询</div>
      
      </div>
      <div style="background-color:#fff;" class="search_box">
        <el-row class="search" :gutter="6">
          <el-col :span="2">
            <div class="label">订单号:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="orderCode" clearable size="small" placeholder="订单编号"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">用户:</div>
          </el-col>
          <el-col :span="5">
            <el-input v-model="mobile" clearable size="small" placeholder="用户"></el-input>
          </el-col>
          <el-col :span="2">
            <div class="label">时间:</div>
          </el-col>
          <el-col :span="10">
              <el-date-picker
                size="small"
                v-model="createdTime"
                type="daterange"
                value-format="yyyy-MM-dd"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                >
              </el-date-picker>  
          </el-col>
          <el-col :span="6" align="center">
            <div class="filtrate_seek_sousuo" @click="geting()">搜索</div>
          </el-col>
        </el-row>
      </div>
      <div class="content_box">
        <div class="table_title">
          <div class="table_title_box">
            <div class="title_icon">
              <i class="fas fa-bars"></i>
            </div>
            <div class="title_text">数据列表</div>
          </div>
        </div>
        <div class="table">
          <el-table :data="tableData" border style="width: 100%" ref="multipleTable">
            <el-table-column prop="user_mobile" label="用户" align="center"></el-table-column>
            <el-table-column prop="order_code"  label="订单号" align="center"></el-table-column>
            <el-table-column prop="pay_money" width="80" label="付款金额" align="center"></el-table-column>
            <el-table-column prop="created_date" width="240" label="创建时间" align="center"></el-table-column>
             <el-table-column prop="status" label="支付状态" width="80" align="center">
               <template slot-scope="scope">
                 <el-tag type="success" v-if="scope.row.status ==1">已还款</el-tag>
                 <el-tag type="danger" v-else-if="scope.row.status ==2">已作废</el-tag>
                 <el-tag type="info" v-else>未还款</el-tag>
              </template>
             </el-table-column>
            <el-table-column prop="member" width="90" label="审核员" align="center"></el-table-column>
            <el-table-column label="操作" width="100" align="center" name="bianji">
              <template slot-scope="scope">
                <button @click="dialogFormVisible2=true,orderState ='',orderId = scope.row.order_code  " class="button1">操作</button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page_box clearfix">
          <div class="page">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="15"
              :current-page.sync="page"
              @current-change="setPage"
            ></el-pagination>
          </div>
        </div>
      </div>
    </div>
    <noAccess v-else></noAccess>
    <!-- 确认采购 -->
    <el-dialog title="设置还款状态" :visible.sync="dialogFormVisible2" width="33%">
      <el-form>
        <el-form-item label="">
          <el-radio-group v-model="orderState">
            <el-radio :label="0">未还款</el-radio>
            <el-radio :label="1">已还款</el-radio>
            <el-radio :label="2">作废订单</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="set_order_state()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import "../../assets/all.css";
export default {
  name: "list",
  data() {
    return {
      serve: this.$store.state.serve,
      role: true,
      mobile: "",
      username: this.$cookies.get("username"),
      token: this.$cookies.get("token"),
      tableData: [],
      orderCode:'',
      createdTime:'',
      page:1,
      total: 1,
      dialogFormVisible2: false,
      orderState:'',
      orderId:0,
    };
  },
  created() {
    this.$store.state.topActiveId = 11;
    this.$store.state.leftTitle = "白条列表";
    this.geting()
  },
  watch: {
    //监听全选状态
  },
  methods: {
    setPage(v){
      this.page = v;
      this.geting();
    },
    geting(){
        var where = {
          username: this.username,
          token: this.token,
          page:this.page,
          orderCode: this.orderCode,
          mobile:this.mobile,
          date: this.createdTime
        };
        this.axios
          .get(this.serve + "/admin/card_list", {
            params: where
          })
          .then(res => {
            
            this.tableData = [];
            if (res.data.status == "success") {
              this.tableData = res.data.data.results;
              this.total = res.data.data.total == false ? 0 : res.data.data.total;
            } else {
            }
        });
    },
    set_order_state(){ //设置该订单的状态
        let order_code = this.orderId;
        let state = this.orderState;
        console.log(order_code,state);
        if(order_code <= 0 || state ==''){
          this.$message({
            type:"error",
            message:'请选择你要操作的状态！'
          })
        }
        this.$confirm('你确定要改变订单的当前状态吗，请确认?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
            var where = {
                username: this.username,
                token: this.token,
                order_code: order_code,
                state:state,
              };
              this.axios
                .get(this.serve + "/admin/set_order_state", {
                  params: where
                })
                .then(res => {
                  
                  this.tableData = [];
                  if (res.data.status == "success") {
                    this.$message({
                      type:"success",
                      message:'设置成功'
                    })
                  } else {
                    this.$message({
                      type:"error",
                      message:res.data.msg
                    })
                  }
                  this.dialogFormVisible2 = false;
                  this.geting();
              });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消设置'
          });          
        });    
        
    }
  }
};
</script>
<style lang="scss">
.Paylist {
  background: #f5f5f5;
  color: #333;
  min-height: 1000px;
  padding-bottom: 100px;
  .filtrate_seek_sousuo {
    text-align: center;
    line-height: 28px;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(102, 102, 102, 1);
    width: 74px;
    height: 28px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(221, 221, 221, 1);
    position: absolute;
    right: 18px;
    top: 29px;
    cursor: pointer;
  }
  .el-pagination {
    text-align: left;
  }
  .button1 {
    // border: 0;
    border: none;
    outline: none;
    background: none;
    font-size: 14px;
    font-family: "MicrosoftYaHeiLight";
    font-weight: 300;
    color: rgba(51, 51, 51, 1);
    line-height: 18px;
    cursor: pointer;
  }
  .button1:hover {
    color: #0099ff;
  }
  .el-row {
    display: flex;
    justify-content: center;
  }
  .cell {
    color: #606266 !important;
  }
  .center_list_head {
    width: 100%;
    height: 46px;
    // background: orange;
    display: flex;
    justify-content: space-between;
    .center_list_head_left {
      display: flex;
      align-items: center;
      > div {
        margin-left: 10px;
      }
    }
    .center_list_head_rig {
      width: 100px;
      height: 30px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      font-size: 12px;
      font-family: "MicrosoftYaHeiLight";
      font-weight: 300;
      color: rgba(153, 153, 153, 1);
      margin: 7px 30px 0 0;
      line-height: 30px;
      text-align: center;
      cursor: pointer;
    }
    .center_list_head_rig:hover {
      color: #0099ff;
    }
  }

  .menu1 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .btn3 {
      margin-right: 0;
      i {
        font-style: normal;
        color: #f64e62;
      }
    }
    .btn3:hover i {
      color: #fff;
    }
  }
  .search_box {
    border: 1px solid rgba(221, 221, 221, 1);
    padding-left: 0px;
  }
  .search {
    display: flex;
    justify-content: left;
  }
  .search .el-col {
    line-height: 80px;
  }
  .label {
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .el-table_1_column_3 .cell {
    overflow: hidden;
    text-align: center;
  }
}
</style>